
export class PositionCoordinates {
    public w?: number;
    public yh?: number;
    public element?: JQuery;

    constructor(public x: number, public y: number) {}

}
